import { MessageService } from 'primeng/api';
import {
  Agendamento,
  FormAgendamento,
  HorariosDisponiveisAgendamento,
  LocalAgendamento,
} from 'src/app/models/agendamento.model';
import { AgendamentoService } from './../../../services/agendamento.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-agendamento-atendimento',
  templateUrl: './atendimento.component.html',
  styleUrls: ['./atendimento.component.css'],
})
export class AgendamentoAtendimentoComponent implements OnInit {
  form!: FormGroup;
  isSending = false;
  isLoadingLocais = true;
  isLoadingHorario = false;
  agendado!: Agendamento;
  locais: LocalAgendamento[] = [];
  horarios: HorariosDisponiveisAgendamento[] = [];

  constructor(
    private fb: FormBuilder,
    private service: AgendamentoService,
    private msgService: MessageService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      local: [{ value: null, disabled: true }, [Validators.required]],
      horario: [{ value: null, disabled: true }, [Validators.required]],
      nome: [null, [Validators.required]],
      telefone: [null, [Validators.required]],
      cpf: [null, [Validators.required]],
    });

    this.service.getLocais().subscribe({
      next: (locais) => {
        this.locais = locais;
        this.isLoadingLocais = false;
        this.form.get('local')?.enable();
      },
      error: (erro) => {
        this.isLoadingLocais = false;
        this._errorMessage(
          'Não foi possível carregar os locais de atendimento, tente novamente mais tarde'
        );
      },
    });
  }

  onSelectLocal() {
    if (this.form.value['local'] == null) return;

    this.isLoadingHorario = true;
    this.form.get('horario')?.disable();
    this.form.get('horario')?.setValue(null);

    this.service.getHorarios(this.form.value['local'].id).subscribe({
      next: (horarios) => {
        this.horarios = horarios;
        this.form.get('horario')?.enable();
        this.isLoadingHorario = false;
      },
      error: (error) => {
        this.form.get('horario')?.enable();
        this.isLoadingHorario = false;
        this._errorMessage(
          'Não foi possível carregar os horários de atendimento, tente novamente mais tarde'
        );
      },
    });
  }

  onSubmit() {
    this.isSending = true;
    const form = new FormAgendamento(
      this.form.get('local')?.value?.id,
      this.form.get('horario')?.value?.horario,
      this.form.get('nome')?.value,
      this.form.get('telefone')?.value,
      this.form.get('cpf')?.value
    );

    this.service.postAgendamento(form).subscribe({
      next: (res) => {
        this.agendado = res;
        this.isSending = false;
        this.form.reset();
      },
      error: (err) => {
        if (err.error.messages) {
          const messages: [] = err.error.messages;
          messages.forEach((m: any) => this._errorMessage(m.message));
        } else {
          this._errorMessage(err.error.message);
          this.onSelectLocal();
        }

        this.isSending = false;
      },
    });
  }

  _errorMessage(message: string) {
    this.msgService.add({
      severity: 'error',
      detail: message,
    });
  }
}
